/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import styled from 'styled-components';
import { Box, FormField } from 'grommet';

// Necessary because using the Grommet Box's gap prop adds divs
export const StyledEditRecipientRow = styled(Box)`
  gap: 24px;
`;
export const StyledFieldRow = styled(Box)`
  gap: 8px;
`;
export const StyledNameField = styled(FormField)`
  flex: 1;
`;
export const StyledMiddleNameField = styled(FormField)`
  flex: 0.75;
`;
export const StyledSuffixNameField = styled(FormField)`
  flex: 0.25;
`;
export const StyledPre = styled('pre')`
  display: inline;
  font-family: inherit;
`;